import { createMachine, assign, spawn } from 'xstate';
import { v4 as uuidv4 } from 'uuid';

import { createToastMachine } from '../toast';

import { DEFAULT_HIDE_TIME } from './constants';
import { Context, Events } from './types';

const initialContext: Context = {
  items: [],
};

export const toasts = createMachine<Context, Events>({
  id: 'toasts',
  predictableActionArguments: true,
  initial: 'idle',
  context: initialContext,
  on: {
    HIDE_TOAST: {
      actions: [
        assign((ctx, event) => ({
          items: ctx.items.filter(({ id }) => id !== event.messageId),
        })),
      ],
    },
    SHOW_TOAST: {
      actions: [
        assign((ctx, event) => {
          const id = uuidv4();

          return {
            items: [
              ...ctx.items,
              {
                id,
                message: event.message,
                level: event.level,
                ref: spawn(
                  createToastMachine(
                    id,
                    event.visibilityTimeMs || DEFAULT_HIDE_TIME
                  )
                ),
              },
            ],
          };
        }),
      ],
    },
  },
  states: {
    idle: {},
  },
});
